module.exports = __webpack_public_path__ + "static/img/office1.fe2ce8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/office1.jpg
// module id = wmdC
// module chunks = 1